import { useI18n } from 'AurionCR/components';

export const useTranslate = () => {
  const { t, tp } = useI18n();
  return { t, tp };
};
